module.exports = __webpack_public_path__ + "img/icon-replenishment.59ef6775.svg";